import React from "react";
import { ReactComponent as InstagramIcon } from "../icons/instagram.svg";
import { ReactComponent as FacebookIcon } from "../icons/facebook.svg";
import { ReactComponent as TwitterIcon } from "../icons/twitter.svg";
import { ReactComponent as TikTokIcon } from "../icons/tiktok.svg";
import { useTranslation } from "react-i18next";

const SocialLinks = () => {
  const { t } = useTranslation();

  return (
    <div className="social-links-container">
      <hr className="styled-hr-home" />
      <div className="social-links">
        <a
          href="https://www.instagram.com/mcknighthomme?igsh=MTVtZnNsajl6emV4Mw%3D%3D&utm_source=qr"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <InstagramIcon className="social-icon" />
        </a>
        <a
          href="https://www.instagram.com/mcknighthomme?igsh=MTVtZnNsajl6emV4Mw%3D%3D&utm_source=qr"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <FacebookIcon className="social-icon" />
        </a>
        <a
          href="https://www.tiktok.com/@mcknighthomme?_r=1&_t=ZN-97YEHQOyRrq"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Twitter"
        >
          <TwitterIcon className="social-icon" />
        </a>
        <a
          href="https://www.tiktok.com/@mcknighthomme?_r=1&_t=ZN-97YEHQOyRrq"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="TikTok"
        >
          <TikTokIcon className="social-icon" />
        </a>
      </div>
      <hr className="styled-hr-home-bottom" />
      <div className="footer-details">
        <p>{t("Online Bespoke Fitting")}</p>
        <p>{t("Home Delivery")}</p>
        <p>{t("Free Test Outfit")}</p>
        <p>{t("24/7 Customer Service")}</p>
      </div>
    </div>
  );
};

export default SocialLinks;
